import { Box, Stack } from "@mui/material";

import { FormBlock } from "@/forms-design-system/FormBlock/FormBlock";
import { useMediaQuery } from "@/hooks/useMediaQuery";

type ThemedAuctionFormSummaryLayoutProps = {
  slots: {
    banner?: React.ReactNode;
    organizationLogo: React.ReactNode;
    status?: React.ReactNode;
    title: React.ReactNode;
    date: React.ReactNode;
    location?: React.ReactNode;
    campaignTarget?: React.ReactNode;
    description?: React.ReactNode;
  };
  forceInlined?: boolean;
};

export const ThemedAuctionFormSummaryLayout = ({
  slots,
  forceInlined = false,
}: ThemedAuctionFormSummaryLayoutProps) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <FormBlock
      variant={isSmallScreen || forceInlined ? "inline" : "elevated-card"}
      fullWidth
      sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 2 }}
    >
      {!isSmallScreen && slots.banner}
      {isSmallScreen && slots.organizationLogo}
      {slots.status && <Box marginBlockStart={0.5}>{slots.status}</Box>}
      {slots.title}
      <Stack width="100%" gap={1}>
        {slots.date}
        {slots.location}
      </Stack>
      {slots.campaignTarget}
      {slots.description}
    </FormBlock>
  );
};
